module.exports = __webpack_public_path__ + "static/media/BookReviewEditorial.858d942d.jpg";